import { g as Pe, _ as i, m as so, b as Ce, P as t, d as z, o as Ue, p as Ye, a as Oe } from "./createTheme-6e68f5ca.js";
import * as h from "react";
import { g as ke, s as _, u as ze, w as io, b as dt, i as qe, c as ce, x as lo, a as _e, y as $t, z as ge, A as co, M as uo, C as po, d as fo, h as mo, D as Ft, f as it, E as Fe, F as lt, H as pt, I as ft, B as bo, r as vo, L as Lt, J as We, K as Wt, N as ve, O as St, Q as It, t as go, R as ho, S as yo } from "./Search-4d6031ad.js";
import { jsx as d, jsxs as Ae } from "react/jsx-runtime";
import { d as Ot } from "./Tooltip-34b208dc.js";
const xo = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
}, Co = xo;
function ko(e) {
  return Pe("MuiCollapse", e);
}
ke("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const To = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], $o = (e) => {
  const {
    orientation: o,
    classes: n
  } = e, r = {
    root: ["root", `${o}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${o}`],
    wrapperInner: ["wrapperInner", `${o}`]
  };
  return _e(r, ko, n);
}, Lo = _("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.root, o[n.orientation], n.state === "entered" && o.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && o.hidden];
  }
})(({
  theme: e,
  ownerState: o
}) => i({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, o.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, o.state === "entered" && i({
  height: "auto",
  overflow: "visible"
}, o.orientation === "horizontal" && {
  width: "auto"
}), o.state === "exited" && !o.in && o.collapsedSize === "0px" && {
  visibility: "hidden"
})), So = _("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, o) => o.wrapper
})(({
  ownerState: e
}) => i({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), Io = _("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, o) => o.wrapperInner
})(({
  ownerState: e
}) => i({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), mt = /* @__PURE__ */ h.forwardRef(function(o, n) {
  const r = ze({
    props: o,
    name: "MuiCollapse"
  }), {
    addEndListener: a,
    children: p,
    className: b,
    collapsedSize: f = "0px",
    component: u,
    easing: x,
    in: k,
    onEnter: $,
    onEntered: V,
    onEntering: I,
    onExit: O,
    onExited: g,
    onExiting: w,
    orientation: te = "vertical",
    style: R,
    timeout: P = so.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: U = io
  } = r, ue = Ce(r, To), B = i({}, r, {
    orientation: te,
    collapsedSize: f
  }), K = $o(B), de = dt(), oe = h.useRef(), C = h.useRef(null), D = h.useRef(), H = typeof f == "number" ? `${f}px` : f, Y = te === "horizontal", T = Y ? "width" : "height";
  h.useEffect(() => () => {
    clearTimeout(oe.current);
  }, []);
  const ne = h.useRef(null), Z = qe(n, ne), ae = (m) => (F) => {
    if (m) {
      const W = ne.current;
      F === void 0 ? m(W) : m(W, F);
    }
  }, X = () => C.current ? C.current[Y ? "clientWidth" : "clientHeight"] : 0, re = ae((m, F) => {
    C.current && Y && (C.current.style.position = "absolute"), m.style[T] = H, $ && $(m, F);
  }), Ne = ae((m, F) => {
    const W = X();
    C.current && Y && (C.current.style.position = "");
    const {
      duration: J,
      easing: se
    } = $t({
      style: R,
      timeout: P,
      easing: x
    }, {
      mode: "enter"
    });
    if (P === "auto") {
      const fe = de.transitions.getAutoHeightDuration(W);
      m.style.transitionDuration = `${fe}ms`, D.current = fe;
    } else
      m.style.transitionDuration = typeof J == "string" ? J : `${J}ms`;
    m.style[T] = `${W}px`, m.style.transitionTimingFunction = se, I && I(m, F);
  }), Te = ae((m, F) => {
    m.style[T] = "auto", V && V(m, F);
  }), be = ae((m) => {
    m.style[T] = `${X()}px`, O && O(m);
  }), q = ae(g), $e = ae((m) => {
    const F = X(), {
      duration: W,
      easing: J
    } = $t({
      style: R,
      timeout: P,
      easing: x
    }, {
      mode: "exit"
    });
    if (P === "auto") {
      const se = de.transitions.getAutoHeightDuration(F);
      m.style.transitionDuration = `${se}ms`, D.current = se;
    } else
      m.style.transitionDuration = typeof W == "string" ? W : `${W}ms`;
    m.style[T] = H, m.style.transitionTimingFunction = J, w && w(m);
  });
  return /* @__PURE__ */ d(U, i({
    in: k,
    onEnter: re,
    onEntered: Te,
    onEntering: Ne,
    onExit: be,
    onExited: q,
    onExiting: $e,
    addEndListener: (m) => {
      P === "auto" && (oe.current = setTimeout(m, D.current || 0)), a && a(ne.current, m);
    },
    nodeRef: ne,
    timeout: P === "auto" ? null : P
  }, ue, {
    children: (m, F) => /* @__PURE__ */ d(Lo, i({
      as: u,
      className: ce(K.root, b, {
        entered: K.entered,
        exited: !k && H === "0px" && K.hidden
      }[m]),
      style: i({
        [Y ? "minWidth" : "minHeight"]: H
      }, R),
      ownerState: i({}, B, {
        state: m
      }),
      ref: Z
    }, F, {
      children: /* @__PURE__ */ d(So, {
        ownerState: i({}, B, {
          state: m
        }),
        className: K.wrapper,
        ref: C,
        children: /* @__PURE__ */ d(Io, {
          ownerState: i({}, B, {
            state: m
          }),
          className: K.wrapperInner,
          children: p
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (mt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: t.func,
  /**
   * The content node to be collapsed.
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: t.oneOfType([t.number, t.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: lo,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: t.oneOfType([t.shape({
    enter: t.string,
    exit: t.string
  }), t.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: t.bool,
  /**
   * @ignore
   */
  onEnter: t.func,
  /**
   * @ignore
   */
  onEntered: t.func,
  /**
   * @ignore
   */
  onEntering: t.func,
  /**
   * @ignore
   */
  onExit: t.func,
  /**
   * @ignore
   */
  onExited: t.func,
  /**
   * @ignore
   */
  onExiting: t.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: t.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: t.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: t.oneOfType([t.oneOf(["auto"]), t.number, t.shape({
    appear: t.number,
    enter: t.number,
    exit: t.number
  })])
});
mt.muiSupportAuto = !0;
const An = mt;
function Oo(e) {
  return Pe("MuiAlert", e);
}
const Po = ke("MuiAlert", ["root", "action", "icon", "message", "filled", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]), Pt = Po, Mo = ge(/* @__PURE__ */ d("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), No = ge(/* @__PURE__ */ d("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), Eo = ge(/* @__PURE__ */ d("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), wo = ge(/* @__PURE__ */ d("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), Ro = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"], Ao = (e) => {
  const {
    variant: o,
    color: n,
    severity: r,
    classes: a
  } = e, p = {
    root: ["root", `${o}${z(n || r)}`, `${o}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return _e(p, Oo, a);
}, zo = _(co, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.root, o[n.variant], o[`${n.variant}${z(n.color || n.severity)}`]];
  }
})(({
  theme: e,
  ownerState: o
}) => {
  const n = e.palette.mode === "light" ? Ue : Ye, r = e.palette.mode === "light" ? Ye : Ue, a = o.color || o.severity;
  return i({}, e.typography.body2, {
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px"
  }, a && o.variant === "standard" && {
    color: e.vars ? e.vars.palette.Alert[`${a}Color`] : n(e.palette[a].light, 0.6),
    backgroundColor: e.vars ? e.vars.palette.Alert[`${a}StandardBg`] : r(e.palette[a].light, 0.9),
    [`& .${Pt.icon}`]: e.vars ? {
      color: e.vars.palette.Alert[`${a}IconColor`]
    } : {
      color: e.palette[a].main
    }
  }, a && o.variant === "outlined" && {
    color: e.vars ? e.vars.palette.Alert[`${a}Color`] : n(e.palette[a].light, 0.6),
    border: `1px solid ${(e.vars || e).palette[a].light}`,
    [`& .${Pt.icon}`]: e.vars ? {
      color: e.vars.palette.Alert[`${a}IconColor`]
    } : {
      color: e.palette[a].main
    }
  }, a && o.variant === "filled" && i({
    fontWeight: e.typography.fontWeightMedium
  }, e.vars ? {
    color: e.vars.palette.Alert[`${a}FilledColor`],
    backgroundColor: e.vars.palette.Alert[`${a}FilledBg`]
  } : {
    backgroundColor: e.palette.mode === "dark" ? e.palette[a].dark : e.palette[a].main,
    color: e.palette.getContrastText(e.palette[a].main)
  }));
}), _o = _("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, o) => o.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), Vo = _("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, o) => o.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), Mt = _("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, o) => o.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), Nt = {
  success: /* @__PURE__ */ d(Mo, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ d(No, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ d(Eo, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ d(wo, {
    fontSize: "inherit"
  })
}, Ut = /* @__PURE__ */ h.forwardRef(function(o, n) {
  var r, a, p, b, f, u;
  const x = ze({
    props: o,
    name: "MuiAlert"
  }), {
    action: k,
    children: $,
    className: V,
    closeText: I = "Close",
    color: O,
    components: g = {},
    componentsProps: w = {},
    icon: te,
    iconMapping: R = Nt,
    onClose: P,
    role: U = "alert",
    severity: ue = "success",
    slotProps: B = {},
    slots: K = {},
    variant: de = "standard"
  } = x, oe = Ce(x, Ro), C = i({}, x, {
    color: O,
    severity: ue,
    variant: de
  }), D = Ao(C), H = (r = (a = K.closeButton) != null ? a : g.CloseButton) != null ? r : uo, Y = (p = (b = K.closeIcon) != null ? b : g.CloseIcon) != null ? p : po, T = (f = B.closeButton) != null ? f : w.closeButton, ne = (u = B.closeIcon) != null ? u : w.closeIcon;
  return /* @__PURE__ */ Ae(zo, i({
    role: U,
    elevation: 0,
    ownerState: C,
    className: ce(D.root, V),
    ref: n
  }, oe, {
    children: [te !== !1 ? /* @__PURE__ */ d(_o, {
      ownerState: C,
      className: D.icon,
      children: te || R[ue] || Nt[ue]
    }) : null, /* @__PURE__ */ d(Vo, {
      ownerState: C,
      className: D.message,
      children: $
    }), k != null ? /* @__PURE__ */ d(Mt, {
      ownerState: C,
      className: D.action,
      children: k
    }) : null, k == null && P ? /* @__PURE__ */ d(Mt, {
      ownerState: C,
      className: D.action,
      children: /* @__PURE__ */ d(H, i({
        size: "small",
        "aria-label": I,
        title: I,
        color: "inherit",
        onClick: P
      }, T, {
        children: /* @__PURE__ */ d(Y, i({
          fontSize: "small"
        }, ne))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (Ut.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: t.node,
  /**
   * The content of the component.
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: t.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: t.oneOfType([t.oneOf(["error", "info", "success", "warning"]), t.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: t.shape({
    CloseButton: t.elementType,
    CloseIcon: t.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: t.shape({
    closeButton: t.object,
    closeIcon: t.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: t.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: t.shape({
    error: t.node,
    info: t.node,
    success: t.node,
    warning: t.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: t.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: t.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: t.oneOf(["error", "info", "success", "warning"]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: t.shape({
    closeButton: t.object,
    closeIcon: t.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: t.shape({
    closeButton: t.elementType,
    closeIcon: t.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: t.oneOfType([t.oneOf(["filled", "outlined", "standard"]), t.string])
});
const zn = Ut;
function Do(e, o, n = (r, a) => r === a) {
  return e.length === o.length && e.every((r, a) => n(r, o[a]));
}
const jo = 2;
function Yt(e, o) {
  return e - o;
}
function we(e, o, n) {
  return e == null ? o : Math.min(Math.max(o, e), n);
}
function Et(e, o) {
  var n;
  const {
    index: r
  } = (n = e.reduce((a, p, b) => {
    const f = Math.abs(o - p);
    return a === null || f < a.distance || f === a.distance ? {
      distance: f,
      index: b
    } : a;
  }, null)) != null ? n : {};
  return r;
}
function De(e, o) {
  if (o.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let r = 0; r < n.changedTouches.length; r += 1) {
      const a = n.changedTouches[r];
      if (a.identifier === o.current)
        return {
          x: a.clientX,
          y: a.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function Ge(e, o, n) {
  return (e - o) * 100 / (n - o);
}
function Bo(e, o, n) {
  return (n - o) * e + o;
}
function Ho(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), r = n[0].split(".")[1];
    return (r ? r.length : 0) + parseInt(n[1], 10);
  }
  const o = e.toString().split(".")[1];
  return o ? o.length : 0;
}
function Fo(e, o, n) {
  const r = Math.round((e - n) / o) * o + n;
  return Number(r.toFixed(Ho(o)));
}
function wt({
  values: e,
  newValue: o,
  index: n
}) {
  const r = e.slice();
  return r[n] = o, r.sort(Yt);
}
function je({
  sliderRef: e,
  activeIndex: o,
  setActive: n
}) {
  var r, a;
  const p = Fe(e.current);
  if (!((r = e.current) != null && r.contains(p.activeElement)) || Number(p == null || (a = p.activeElement) == null ? void 0 : a.getAttribute("data-index")) !== o) {
    var b;
    (b = e.current) == null || b.querySelector(`[type="range"][data-index="${o}"]`).focus();
  }
  n && n(o);
}
function Be(e, o) {
  return typeof e == "number" && typeof o == "number" ? e === o : typeof e == "object" && typeof o == "object" ? Do(e, o) : !1;
}
const Wo = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, Uo = (e) => e;
let He;
function ct() {
  return He === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? He = CSS.supports("touch-action", "none") : He = !0), He;
}
function Yo(e) {
  const {
    "aria-labelledby": o,
    defaultValue: n,
    disabled: r = !1,
    disableSwap: a = !1,
    isRtl: p = !1,
    marks: b = !1,
    max: f = 100,
    min: u = 0,
    name: x,
    onChange: k,
    onChangeCommitted: $,
    orientation: V = "horizontal",
    rootRef: I,
    scale: O = Uo,
    step: g = 1,
    tabIndex: w,
    value: te
  } = e, R = h.useRef(), [P, U] = h.useState(-1), [ue, B] = h.useState(-1), [K, de] = h.useState(!1), oe = h.useRef(0), [C, D] = fo({
    controlled: te,
    default: n ?? u,
    name: "Slider"
  }), H = k && ((s, l, c) => {
    const v = s.nativeEvent || s, A = new v.constructor(v.type, v);
    Object.defineProperty(A, "target", {
      writable: !0,
      value: {
        value: l,
        name: x
      }
    }), k(A, l, c);
  }), Y = Array.isArray(C);
  let T = Y ? C.slice().sort(Yt) : [C];
  T = T.map((s) => we(s, u, f));
  const ne = b === !0 && g !== null ? [...Array(Math.floor((f - u) / g) + 1)].map((s, l) => ({
    value: u + g * l
  })) : b || [], Z = ne.map((s) => s.value), {
    isFocusVisibleRef: ae,
    onBlur: X,
    onFocus: re,
    ref: Ne
  } = mo(), [Te, be] = h.useState(-1), q = h.useRef(), $e = qe(Ne, q), Le = qe(I, $e), m = (s) => (l) => {
    var c;
    const v = Number(l.currentTarget.getAttribute("data-index"));
    re(l), ae.current === !0 && be(v), B(v), s == null || (c = s.onFocus) == null || c.call(s, l);
  }, F = (s) => (l) => {
    var c;
    X(l), ae.current === !1 && be(-1), B(-1), s == null || (c = s.onBlur) == null || c.call(s, l);
  };
  Ft(() => {
    if (r && q.current.contains(document.activeElement)) {
      var s;
      (s = document.activeElement) == null || s.blur();
    }
  }, [r]), r && P !== -1 && U(-1), r && Te !== -1 && be(-1);
  const W = (s) => (l) => {
    var c;
    (c = s.onChange) == null || c.call(s, l);
    const v = Number(l.currentTarget.getAttribute("data-index")), A = T[v], Q = Z.indexOf(A);
    let y = l.target.valueAsNumber;
    if (ne && g == null) {
      const S = Z[Z.length - 1];
      y > S ? y = S : y < Z[0] ? y = Z[0] : y = y < A ? Z[Q - 1] : Z[Q + 1];
    }
    if (y = we(y, u, f), Y) {
      a && (y = we(y, T[v - 1] || -1 / 0, T[v + 1] || 1 / 0));
      const S = y;
      y = wt({
        values: T,
        newValue: y,
        index: v
      });
      let N = v;
      a || (N = y.indexOf(S)), je({
        sliderRef: q,
        activeIndex: N
      });
    }
    D(y), be(v), H && !Be(y, C) && H(l, y, v), $ && $(l, y);
  }, J = h.useRef();
  let se = V;
  p && V === "horizontal" && (se += "-reverse");
  const fe = ({
    finger: s,
    move: l = !1
  }) => {
    const {
      current: c
    } = q, {
      width: v,
      height: A,
      bottom: Q,
      left: y
    } = c.getBoundingClientRect();
    let S;
    se.indexOf("vertical") === 0 ? S = (Q - s.y) / A : S = (s.x - y) / v, se.indexOf("-reverse") !== -1 && (S = 1 - S);
    let N;
    if (N = Bo(S, u, f), g)
      N = Fo(N, g, u);
    else {
      const Ee = Et(Z, N);
      N = Z[Ee];
    }
    N = we(N, u, f);
    let pe = 0;
    if (Y) {
      l ? pe = J.current : pe = Et(T, N), a && (N = we(N, T[pe - 1] || -1 / 0, T[pe + 1] || 1 / 0));
      const Ee = N;
      N = wt({
        values: T,
        newValue: N,
        index: pe
      }), a && l || (pe = N.indexOf(Ee), J.current = pe);
    }
    return {
      newValue: N,
      activeIndex: pe
    };
  }, he = it((s) => {
    const l = De(s, R);
    if (!l)
      return;
    if (oe.current += 1, s.type === "mousemove" && s.buttons === 0) {
      ie(s);
      return;
    }
    const {
      newValue: c,
      activeIndex: v
    } = fe({
      finger: l,
      move: !0
    });
    je({
      sliderRef: q,
      activeIndex: v,
      setActive: U
    }), D(c), !K && oe.current > jo && de(!0), H && !Be(c, C) && H(s, c, v);
  }), ie = it((s) => {
    const l = De(s, R);
    if (de(!1), !l)
      return;
    const {
      newValue: c
    } = fe({
      finger: l,
      move: !0
    });
    U(-1), s.type === "touchend" && B(-1), $ && $(s, c), R.current = void 0, L();
  }), M = it((s) => {
    if (r)
      return;
    ct() || s.preventDefault();
    const l = s.changedTouches[0];
    l != null && (R.current = l.identifier);
    const c = De(s, R);
    if (c !== !1) {
      const {
        newValue: A,
        activeIndex: Q
      } = fe({
        finger: c
      });
      je({
        sliderRef: q,
        activeIndex: Q,
        setActive: U
      }), D(A), H && !Be(A, C) && H(s, A, Q);
    }
    oe.current = 0;
    const v = Fe(q.current);
    v.addEventListener("touchmove", he), v.addEventListener("touchend", ie);
  }), L = h.useCallback(() => {
    const s = Fe(q.current);
    s.removeEventListener("mousemove", he), s.removeEventListener("mouseup", ie), s.removeEventListener("touchmove", he), s.removeEventListener("touchend", ie);
  }, [ie, he]);
  h.useEffect(() => {
    const {
      current: s
    } = q;
    return s.addEventListener("touchstart", M, {
      passive: ct()
    }), () => {
      s.removeEventListener("touchstart", M, {
        passive: ct()
      }), L();
    };
  }, [L, M]), h.useEffect(() => {
    r && L();
  }, [r, L]);
  const Se = (s) => (l) => {
    var c;
    if ((c = s.onMouseDown) == null || c.call(s, l), r || l.defaultPrevented || l.button !== 0)
      return;
    l.preventDefault();
    const v = De(l, R);
    if (v !== !1) {
      const {
        newValue: Q,
        activeIndex: y
      } = fe({
        finger: v
      });
      je({
        sliderRef: q,
        activeIndex: y,
        setActive: U
      }), D(Q), H && !Be(Q, C) && H(l, Q, y);
    }
    oe.current = 0;
    const A = Fe(q.current);
    A.addEventListener("mousemove", he), A.addEventListener("mouseup", ie);
  }, ye = Ge(Y ? T[0] : u, u, f), xe = Ge(T[T.length - 1], u, f) - ye, Ke = (s = {}) => {
    const l = lt(s), c = {
      onMouseDown: Se(l || {})
    }, v = i({}, l, c);
    return i({}, s, {
      ref: Le
    }, v);
  }, G = (s) => (l) => {
    var c;
    (c = s.onMouseOver) == null || c.call(s, l);
    const v = Number(l.currentTarget.getAttribute("data-index"));
    B(v);
  }, Ie = (s) => (l) => {
    var c;
    (c = s.onMouseLeave) == null || c.call(s, l), B(-1);
  };
  return {
    active: P,
    axis: se,
    axisProps: Wo,
    dragging: K,
    focusedThumbIndex: Te,
    getHiddenInputProps: (s = {}) => {
      var l;
      const c = lt(s), v = {
        onChange: W(c || {}),
        onFocus: m(c || {}),
        onBlur: F(c || {})
      }, A = i({}, c, v);
      return i({
        tabIndex: w,
        "aria-labelledby": o,
        "aria-orientation": V,
        "aria-valuemax": O(f),
        "aria-valuemin": O(u),
        name: x,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (l = e.step) != null ? l : void 0,
        disabled: r
      }, s, A, {
        style: i({}, Co, {
          direction: p ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: Ke,
    getThumbProps: (s = {}) => {
      const l = lt(s), c = {
        onMouseOver: G(l || {}),
        onMouseLeave: Ie(l || {})
      };
      return i({}, s, l, c);
    },
    marks: ne,
    open: ue,
    range: Y,
    rootRef: Le,
    trackLeap: xe,
    trackOffset: ye,
    values: T,
    getThumbStyle: (s) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: P !== -1 && P !== s ? "none" : void 0
    })
  };
}
function qo(e) {
  return Pe("MuiLinearProgress", e);
}
ke("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const Go = ["className", "color", "value", "valueBuffer", "variant"];
let Me = (e) => e, Rt, At, zt, _t, Vt, Dt;
const ut = 4, Ko = pt(Rt || (Rt = Me`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)), Xo = pt(At || (At = Me`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)), Zo = pt(zt || (zt = Me`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)), Jo = (e) => {
  const {
    classes: o,
    variant: n,
    color: r
  } = e, a = {
    root: ["root", `color${z(r)}`, n],
    dashed: ["dashed", `dashedColor${z(r)}`],
    bar1: ["bar", `barColor${z(r)}`, (n === "indeterminate" || n === "query") && "bar1Indeterminate", n === "determinate" && "bar1Determinate", n === "buffer" && "bar1Buffer"],
    bar2: ["bar", n !== "buffer" && `barColor${z(r)}`, n === "buffer" && `color${z(r)}`, (n === "indeterminate" || n === "query") && "bar2Indeterminate", n === "buffer" && "bar2Buffer"]
  };
  return _e(a, qo, o);
}, bt = (e, o) => o === "inherit" ? "currentColor" : e.vars ? e.vars.palette.LinearProgress[`${o}Bg`] : e.palette.mode === "light" ? Ye(e.palette[o].main, 0.62) : Ue(e.palette[o].main, 0.5), Qo = _("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.root, o[`color${z(n.color)}`], o[n.variant]];
  }
})(({
  ownerState: e,
  theme: o
}) => i({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  "@media print": {
    colorAdjust: "exact"
  },
  backgroundColor: bt(o, e.color)
}, e.color === "inherit" && e.variant !== "buffer" && {
  backgroundColor: "none",
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "currentColor",
    opacity: 0.3
  }
}, e.variant === "buffer" && {
  backgroundColor: "transparent"
}, e.variant === "query" && {
  transform: "rotate(180deg)"
})), en = _("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.dashed, o[`dashedColor${z(n.color)}`]];
  }
})(({
  ownerState: e,
  theme: o
}) => {
  const n = bt(o, e.color);
  return i({
    position: "absolute",
    marginTop: 0,
    height: "100%",
    width: "100%"
  }, e.color === "inherit" && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${n} 0%, ${n} 16%, transparent 42%)`,
    backgroundSize: "10px 10px",
    backgroundPosition: "0 -23px"
  });
}, ft(_t || (_t = Me`
    animation: ${0} 3s infinite linear;
  `), Zo)), tn = _("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.bar, o[`barColor${z(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && o.bar1Indeterminate, n.variant === "determinate" && o.bar1Determinate, n.variant === "buffer" && o.bar1Buffer];
  }
})(({
  ownerState: e,
  theme: o
}) => i({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  backgroundColor: e.color === "inherit" ? "currentColor" : (o.vars || o).palette[e.color].main
}, e.variant === "determinate" && {
  transition: `transform .${ut}s linear`
}, e.variant === "buffer" && {
  zIndex: 1,
  transition: `transform .${ut}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && ft(Vt || (Vt = Me`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), Ko)), on = _("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.bar, o[`barColor${z(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && o.bar2Indeterminate, n.variant === "buffer" && o.bar2Buffer];
  }
})(({
  ownerState: e,
  theme: o
}) => i({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left"
}, e.variant !== "buffer" && {
  backgroundColor: e.color === "inherit" ? "currentColor" : (o.vars || o).palette[e.color].main
}, e.color === "inherit" && {
  opacity: 0.3
}, e.variant === "buffer" && {
  backgroundColor: bt(o, e.color),
  transition: `transform .${ut}s linear`
}), ({
  ownerState: e
}) => (e.variant === "indeterminate" || e.variant === "query") && ft(Dt || (Dt = Me`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), Xo)), qt = /* @__PURE__ */ h.forwardRef(function(o, n) {
  const r = ze({
    props: o,
    name: "MuiLinearProgress"
  }), {
    className: a,
    color: p = "primary",
    value: b,
    valueBuffer: f,
    variant: u = "indeterminate"
  } = r, x = Ce(r, Go), k = i({}, r, {
    color: p,
    variant: u
  }), $ = Jo(k), V = dt(), I = {}, O = {
    bar1: {},
    bar2: {}
  };
  if (u === "determinate" || u === "buffer")
    if (b !== void 0) {
      I["aria-valuenow"] = Math.round(b), I["aria-valuemin"] = 0, I["aria-valuemax"] = 100;
      let g = b - 100;
      V.direction === "rtl" && (g = -g), O.bar1.transform = `translateX(${g}%)`;
    } else
      process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (u === "buffer")
    if (f !== void 0) {
      let g = (f || 0) - 100;
      V.direction === "rtl" && (g = -g), O.bar2.transform = `translateX(${g}%)`;
    } else
      process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ Ae(Qo, i({
    className: ce($.root, a),
    ownerState: k,
    role: "progressbar"
  }, I, {
    ref: n
  }, x, {
    children: [u === "buffer" ? /* @__PURE__ */ d(en, {
      className: $.dashed,
      ownerState: k
    }) : null, /* @__PURE__ */ d(tn, {
      className: $.bar1,
      ownerState: k,
      style: O.bar1
    }), u === "determinate" ? null : /* @__PURE__ */ d(on, {
      className: $.bar2,
      ownerState: k,
      style: O.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" && (qt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: t.oneOfType([t.oneOf(["inherit", "primary", "secondary"]), t.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: t.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: t.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: t.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
const _n = qt, nn = ke("MuiListItemIcon", ["root", "alignItemsFlexStart"]), jt = nn;
function Vn(e) {
  return Pe("MuiListItemText", e);
}
const rn = ke("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), Bt = rn;
function an(e) {
  return Pe("MuiMenuItem", e);
}
const sn = ke("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), Re = sn, ln = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], cn = (e, o) => {
  const {
    ownerState: n
  } = e;
  return [o.root, n.dense && o.dense, n.divider && o.divider, !n.disableGutters && o.gutters];
}, un = (e) => {
  const {
    disabled: o,
    dense: n,
    divider: r,
    disableGutters: a,
    selected: p,
    classes: b
  } = e, u = _e({
    root: ["root", n && "dense", o && "disabled", !a && "gutters", r && "divider", p && "selected"]
  }, an, b);
  return i({}, b, u);
}, dn = _(bo, {
  shouldForwardProp: (e) => vo(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: cn
})(({
  theme: e,
  ownerState: o
}) => i({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !o.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, o.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Re.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Oe(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Re.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Oe(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Re.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Oe(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Oe(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Re.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Re.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${Ot.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${Ot.inset}`]: {
    marginLeft: 52
  },
  [`& .${Bt.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Bt.inset}`]: {
    paddingLeft: 36
  },
  [`& .${jt.root}`]: {
    minWidth: 36
  }
}, !o.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, o.dense && i({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${jt.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), Gt = /* @__PURE__ */ h.forwardRef(function(o, n) {
  const r = ze({
    props: o,
    name: "MuiMenuItem"
  }), {
    autoFocus: a = !1,
    component: p = "li",
    dense: b = !1,
    divider: f = !1,
    disableGutters: u = !1,
    focusVisibleClassName: x,
    role: k = "menuitem",
    tabIndex: $,
    className: V
  } = r, I = Ce(r, ln), O = h.useContext(Lt), g = h.useMemo(() => ({
    dense: b || O.dense || !1,
    disableGutters: u
  }), [O.dense, b, u]), w = h.useRef(null);
  Ft(() => {
    a && (w.current ? w.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [a]);
  const te = i({}, r, {
    dense: g.dense,
    divider: f,
    disableGutters: u
  }), R = un(r), P = qe(w, n);
  let U;
  return r.disabled || (U = $ !== void 0 ? $ : -1), /* @__PURE__ */ d(Lt.Provider, {
    value: g,
    children: /* @__PURE__ */ d(dn, i({
      ref: P,
      role: k,
      tabIndex: U,
      component: p,
      focusVisibleClassName: ce(R.focusVisible, x),
      className: ce(R.root, V)
    }, I, {
      ownerState: te,
      classes: R
    }))
  });
});
process.env.NODE_ENV !== "production" && (Gt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: t.bool,
  /**
   * The content of the component.
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: t.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: t.bool,
  /**
   * @ignore
   */
  disabled: t.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: t.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: t.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: t.string,
  /**
   * @ignore
   */
  role: t.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: t.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * @default 0
   */
  tabIndex: t.number
});
const Dn = Gt, pn = (e) => !e || !We(e), fn = pn;
function mn(e) {
  return Pe("MuiSlider", e);
}
const bn = ke("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), le = bn, vn = (e) => {
  const {
    open: o
  } = e;
  return {
    offset: ce(o && le.valueLabelOpen),
    circle: le.valueLabelCircle,
    label: le.valueLabelLabel
  };
};
function Kt(e) {
  const {
    children: o,
    className: n,
    value: r
  } = e, a = vn(e);
  return o ? /* @__PURE__ */ h.cloneElement(o, {
    className: ce(o.props.className)
  }, /* @__PURE__ */ Ae(h.Fragment, {
    children: [o.props.children, /* @__PURE__ */ d("span", {
      className: ce(a.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ d("span", {
        className: a.circle,
        children: /* @__PURE__ */ d("span", {
          className: a.label,
          children: r
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (Kt.propTypes = {
  children: t.element.isRequired,
  className: t.string,
  value: t.node
});
const gn = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function Ht(e) {
  return e;
}
const hn = _("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.root, o[`color${z(n.color)}`], n.size !== "medium" && o[`size${z(n.size)}`], n.marked && o.marked, n.orientation === "vertical" && o.vertical, n.track === "inverted" && o.trackInverted, n.track === !1 && o.trackFalse];
  }
})(({
  theme: e,
  ownerState: o
}) => i({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  color: (e.vars || e).palette[o.color].main,
  WebkitTapHighlightColor: "transparent"
}, o.orientation === "horizontal" && i({
  height: 4,
  width: "100%",
  padding: "13px 0",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "20px 0"
  }
}, o.size === "small" && {
  height: 2
}, o.marked && {
  marginBottom: 20
}), o.orientation === "vertical" && i({
  height: "100%",
  width: 4,
  padding: "0 13px",
  // The primary input mechanism of the device includes a pointing device of limited accuracy.
  "@media (pointer: coarse)": {
    // Reach 42px touch target, about ~8mm on screen.
    padding: "0 20px"
  }
}, o.size === "small" && {
  width: 2
}, o.marked && {
  marginRight: 44
}), {
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${le.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${le.dragging}`]: {
    [`& .${le.thumb}, & .${le.track}`]: {
      transition: "none"
    }
  }
})), yn = _("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, o) => o.rail
})(({
  ownerState: e
}) => i({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38
}, e.orientation === "horizontal" && {
  width: "100%",
  height: "inherit",
  top: "50%",
  transform: "translateY(-50%)"
}, e.orientation === "vertical" && {
  height: "100%",
  width: "inherit",
  left: "50%",
  transform: "translateX(-50%)"
}, e.track === "inverted" && {
  opacity: 1
})), xn = _("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, o) => o.track
})(({
  theme: e,
  ownerState: o
}) => {
  const n = (
    // Same logic as the LinearProgress track color
    e.palette.mode === "light" ? Ye(e.palette[o.color].main, 0.62) : Ue(e.palette[o.color].main, 0.5)
  );
  return i({
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    })
  }, o.size === "small" && {
    border: "none"
  }, o.orientation === "horizontal" && {
    height: "inherit",
    top: "50%",
    transform: "translateY(-50%)"
  }, o.orientation === "vertical" && {
    width: "inherit",
    left: "50%",
    transform: "translateX(-50%)"
  }, o.track === !1 && {
    display: "none"
  }, o.track === "inverted" && {
    backgroundColor: e.vars ? e.vars.palette.Slider[`${o.color}Track`] : n,
    borderColor: e.vars ? e.vars.palette.Slider[`${o.color}Track`] : n
  });
}), Cn = _("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, o) => {
    const {
      ownerState: n
    } = e;
    return [o.thumb, o[`thumbColor${z(n.color)}`], n.size !== "medium" && o[`thumbSize${z(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: o
}) => i({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  })
}, o.size === "small" && {
  width: 12,
  height: 12
}, o.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-50%, -50%)"
}, o.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 50%)"
}, {
  "&:before": i({
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  }, o.size === "small" && {
    boxShadow: "none"
  }),
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&:hover, &.${le.focusVisible}`]: {
    boxShadow: `0px 0px 0px 8px ${e.vars ? `rgba(${e.vars.palette[o.color].mainChannel} / 0.16)` : Oe(e.palette[o.color].main, 0.16)}`,
    "@media (hover: none)": {
      boxShadow: "none"
    }
  },
  [`&.${le.active}`]: {
    boxShadow: `0px 0px 0px 14px ${e.vars ? `rgba(${e.vars.palette[o.color].mainChannel} / 0.16)` : Oe(e.palette[o.color].main, 0.16)}`
  },
  [`&.${le.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  }
})), kn = _(Kt, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, o) => o.valueLabel
})(({
  theme: e,
  ownerState: o
}) => i({
  [`&.${le.valueLabelOpen}`]: {
    transform: `${o.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(1)`
  },
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  transform: `${o.orientation === "vertical" ? "translateY(-50%)" : "translateY(-100%)"} scale(0)`,
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem"
}, o.orientation === "horizontal" && {
  top: "-10px",
  transformOrigin: "bottom center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, 50%) rotate(45deg)",
    backgroundColor: "inherit",
    bottom: 0,
    left: "50%"
  }
}, o.orientation === "vertical" && {
  right: o.size === "small" ? "20px" : "30px",
  top: "50%",
  transformOrigin: "right center",
  "&:before": {
    position: "absolute",
    content: '""',
    width: 8,
    height: 8,
    transform: "translate(-50%, -50%) rotate(45deg)",
    backgroundColor: "inherit",
    right: -8,
    top: "50%"
  }
}, o.size === "small" && {
  fontSize: e.typography.pxToRem(12),
  padding: "0.25rem 0.5rem"
})), Tn = _("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => Wt(e) && e !== "markActive",
  overridesResolver: (e, o) => {
    const {
      markActive: n
    } = e;
    return [o.mark, n && o.markActive];
  }
})(({
  theme: e,
  ownerState: o,
  markActive: n
}) => i({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor"
}, o.orientation === "horizontal" && {
  top: "50%",
  transform: "translate(-1px, -50%)"
}, o.orientation === "vertical" && {
  left: "50%",
  transform: "translate(-50%, 1px)"
}, n && {
  backgroundColor: (e.vars || e).palette.background.paper,
  opacity: 0.8
})), $n = _("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => Wt(e) && e !== "markLabelActive",
  overridesResolver: (e, o) => o.markLabel
})(({
  theme: e,
  ownerState: o,
  markLabelActive: n
}) => i({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap"
}, o.orientation === "horizontal" && {
  top: 30,
  transform: "translateX(-50%)",
  "@media (pointer: coarse)": {
    top: 40
  }
}, o.orientation === "vertical" && {
  left: 36,
  transform: "translateY(50%)",
  "@media (pointer: coarse)": {
    left: 44
  }
}, n && {
  color: (e.vars || e).palette.text.primary
})), Ln = (e) => {
  const {
    disabled: o,
    dragging: n,
    marked: r,
    orientation: a,
    track: p,
    classes: b,
    color: f,
    size: u
  } = e, x = {
    root: ["root", o && "disabled", n && "dragging", r && "marked", a === "vertical" && "vertical", p === "inverted" && "trackInverted", p === !1 && "trackFalse", f && `color${z(f)}`, u && `size${z(u)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", o && "disabled", u && `thumbSize${z(u)}`, f && `thumbColor${z(f)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return _e(x, mn, b);
}, Sn = ({
  children: e
}) => e, Xt = /* @__PURE__ */ h.forwardRef(function(o, n) {
  var r, a, p, b, f, u, x, k, $, V, I, O, g, w, te, R, P, U, ue, B, K, de, oe, C;
  const D = ze({
    props: o,
    name: "MuiSlider"
  }), Y = dt().direction === "rtl", {
    "aria-label": T,
    "aria-valuetext": ne,
    "aria-labelledby": Z,
    // eslint-disable-next-line react/prop-types
    component: ae = "span",
    components: X = {},
    componentsProps: re = {},
    color: Ne = "primary",
    classes: Te,
    className: be,
    disableSwap: q = !1,
    disabled: $e = !1,
    getAriaLabel: Le,
    getAriaValueText: m,
    marks: F = !1,
    max: W = 100,
    min: J = 0,
    orientation: se = "horizontal",
    size: fe = "medium",
    step: he = 1,
    scale: ie = Ht,
    slotProps: M,
    slots: L,
    track: Se = "normal",
    valueLabelDisplay: ye = "off",
    valueLabelFormat: xe = Ht
  } = D, Ke = Ce(D, gn), G = i({}, D, {
    isRtl: Y,
    max: W,
    min: J,
    classes: Te,
    disabled: $e,
    disableSwap: q,
    orientation: se,
    marks: F,
    color: Ne,
    size: fe,
    step: he,
    scale: ie,
    track: Se,
    valueLabelDisplay: ye,
    valueLabelFormat: xe
  }), {
    axisProps: Ie,
    getRootProps: vt,
    getHiddenInputProps: gt,
    getThumbProps: ht,
    open: s,
    active: l,
    axis: c,
    focusedThumbIndex: v,
    range: A,
    dragging: Q,
    marks: y,
    values: S,
    trackOffset: N,
    trackLeap: pe,
    getThumbStyle: Ee
  } = Yo(i({}, G, {
    rootRef: n
  }));
  G.marked = y.length > 0 && y.some((E) => E.label), G.dragging = Q, G.focusedThumbIndex = v;
  const ee = Ln(G), Xe = (r = (a = L == null ? void 0 : L.root) != null ? a : X.Root) != null ? r : hn, yt = (p = (b = L == null ? void 0 : L.rail) != null ? b : X.Rail) != null ? p : yn, xt = (f = (u = L == null ? void 0 : L.track) != null ? u : X.Track) != null ? f : xn, Ct = (x = (k = L == null ? void 0 : L.thumb) != null ? k : X.Thumb) != null ? x : Cn, kt = ($ = (V = L == null ? void 0 : L.valueLabel) != null ? V : X.ValueLabel) != null ? $ : kn, Ze = (I = (O = L == null ? void 0 : L.mark) != null ? O : X.Mark) != null ? I : Tn, Je = (g = (w = L == null ? void 0 : L.markLabel) != null ? w : X.MarkLabel) != null ? g : $n, Tt = (te = (R = L == null ? void 0 : L.input) != null ? R : X.Input) != null ? te : "input", Qe = (P = M == null ? void 0 : M.root) != null ? P : re.root, Zt = (U = M == null ? void 0 : M.rail) != null ? U : re.rail, et = (ue = M == null ? void 0 : M.track) != null ? ue : re.track, tt = (B = M == null ? void 0 : M.thumb) != null ? B : re.thumb, ot = (K = M == null ? void 0 : M.valueLabel) != null ? K : re.valueLabel, Jt = (de = M == null ? void 0 : M.mark) != null ? de : re.mark, Qt = (oe = M == null ? void 0 : M.markLabel) != null ? oe : re.markLabel, eo = (C = M == null ? void 0 : M.input) != null ? C : re.input, to = ve({
    elementType: Xe,
    getSlotProps: vt,
    externalSlotProps: Qe,
    externalForwardedProps: Ke,
    additionalProps: i({}, fn(Xe) && {
      as: ae
    }),
    ownerState: i({}, G, Qe == null ? void 0 : Qe.ownerState),
    className: [ee.root, be]
  }), oo = ve({
    elementType: yt,
    externalSlotProps: Zt,
    ownerState: G,
    className: ee.rail
  }), no = ve({
    elementType: xt,
    externalSlotProps: et,
    additionalProps: {
      style: i({}, Ie[c].offset(N), Ie[c].leap(pe))
    },
    ownerState: i({}, G, et == null ? void 0 : et.ownerState),
    className: ee.track
  }), nt = ve({
    elementType: Ct,
    getSlotProps: ht,
    externalSlotProps: tt,
    ownerState: i({}, G, tt == null ? void 0 : tt.ownerState),
    className: ee.thumb
  }), ro = ve({
    elementType: kt,
    externalSlotProps: ot,
    ownerState: i({}, G, ot == null ? void 0 : ot.ownerState),
    className: ee.valueLabel
  }), rt = ve({
    elementType: Ze,
    externalSlotProps: Jt,
    ownerState: G,
    className: ee.mark
  }), at = ve({
    elementType: Je,
    externalSlotProps: Qt,
    ownerState: G,
    className: ee.markLabel
  }), ao = ve({
    elementType: Tt,
    getSlotProps: gt,
    externalSlotProps: eo,
    ownerState: G
  });
  return /* @__PURE__ */ Ae(Xe, i({}, to, {
    children: [/* @__PURE__ */ d(yt, i({}, oo)), /* @__PURE__ */ d(xt, i({}, no)), y.filter((E) => E.value >= J && E.value <= W).map((E, j) => {
      const st = Ge(E.value, J, W), Ve = Ie[c].offset(st);
      let me;
      return Se === !1 ? me = S.indexOf(E.value) !== -1 : me = Se === "normal" && (A ? E.value >= S[0] && E.value <= S[S.length - 1] : E.value <= S[0]) || Se === "inverted" && (A ? E.value <= S[0] || E.value >= S[S.length - 1] : E.value >= S[0]), /* @__PURE__ */ Ae(h.Fragment, {
        children: [/* @__PURE__ */ d(Ze, i({
          "data-index": j
        }, rt, !We(Ze) && {
          markActive: me
        }, {
          style: i({}, Ve, rt.style),
          className: ce(rt.className, me && ee.markActive)
        })), E.label != null ? /* @__PURE__ */ d(Je, i({
          "aria-hidden": !0,
          "data-index": j
        }, at, !We(Je) && {
          markLabelActive: me
        }, {
          style: i({}, Ve, at.style),
          className: ce(ee.markLabel, at.className, me && ee.markLabelActive),
          children: E.label
        })) : null]
      }, j);
    }), S.map((E, j) => {
      const st = Ge(E, J, W), Ve = Ie[c].offset(st), me = ye === "off" ? Sn : kt;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ d(me, i({}, !We(me) && {
          valueLabelFormat: xe,
          valueLabelDisplay: ye,
          value: typeof xe == "function" ? xe(ie(E), j) : xe,
          index: j,
          open: s === j || l === j || ye === "on",
          disabled: $e
        }, ro, {
          children: /* @__PURE__ */ d(Ct, i({
            "data-index": j
          }, nt, {
            className: ce(ee.thumb, nt.className, l === j && ee.active, v === j && ee.focusVisible),
            style: i({}, Ve, Ee(j), nt.style),
            children: /* @__PURE__ */ d(Tt, i({
              "data-index": j,
              "aria-label": Le ? Le(j) : T,
              "aria-valuenow": ie(E),
              "aria-labelledby": Z,
              "aria-valuetext": m ? m(ie(E), j) : ne,
              value: S[j]
            }, ao))
          }))
        }), j)
      );
    })]
  }));
});
process.env.NODE_ENV !== "production" && (Xt.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The label of the slider.
   */
  "aria-label": St(t.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": t.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": St(t.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: t.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: t.object,
  /**
   * @ignore
   */
  className: t.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: t.oneOfType([t.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), t.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: t.shape({
    Input: t.elementType,
    Mark: t.elementType,
    MarkLabel: t.elementType,
    Rail: t.elementType,
    Root: t.elementType,
    Thumb: t.elementType,
    Track: t.elementType,
    ValueLabel: t.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: t.shape({
    input: t.oneOfType([t.func, t.object]),
    mark: t.oneOfType([t.func, t.object]),
    markLabel: t.oneOfType([t.func, t.object]),
    rail: t.oneOfType([t.func, t.object]),
    root: t.oneOfType([t.func, t.object]),
    thumb: t.oneOfType([t.func, t.object]),
    track: t.oneOfType([t.func, t.object]),
    valueLabel: t.oneOfType([t.func, t.shape({
      children: t.element,
      className: t.string,
      open: t.bool,
      style: t.object,
      value: t.number,
      valueLabelDisplay: t.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: t.oneOfType([t.arrayOf(t.number), t.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: t.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: t.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: t.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: t.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: t.oneOfType([t.arrayOf(t.shape({
    label: t.node,
    value: t.number.isRequired
  })), t.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: t.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: t.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: t.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: t.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: t.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: t.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: t.func,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: t.oneOfType([t.oneOf(["small", "medium"]), t.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: t.shape({
    input: t.oneOfType([t.func, t.object]),
    mark: t.oneOfType([t.func, t.object]),
    markLabel: t.oneOfType([t.func, t.object]),
    rail: t.oneOfType([t.func, t.object]),
    root: t.oneOfType([t.func, t.object]),
    thumb: t.oneOfType([t.func, t.object]),
    track: t.oneOfType([t.func, t.object]),
    valueLabel: t.oneOfType([t.func, t.shape({
      children: t.element,
      className: t.string,
      open: t.bool,
      style: t.object,
      value: t.number,
      valueLabelDisplay: t.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: t.shape({
    input: t.elementType,
    mark: t.elementType,
    markLabel: t.elementType,
    rail: t.elementType,
    root: t.elementType,
    thumb: t.elementType,
    track: t.elementType,
    valueLabel: t.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: t.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: t.oneOfType([t.arrayOf(t.oneOfType([t.func, t.object, t.bool])), t.func, t.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: t.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: t.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: t.oneOfType([t.arrayOf(t.number), t.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: t.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: t.oneOfType([t.func, t.string])
});
const jn = Xt;
function In(e) {
  const {
    theme: o,
    name: n,
    props: r
  } = e;
  if (!o || !o.components || !o.components[n] || !o.components[n].defaultProps)
    return r;
  const a = i({}, r), p = o.components[n].defaultProps;
  let b;
  for (b in p)
    a[b] === void 0 && (a[b] = p[b]);
  return a;
}
const On = ["defaultTheme", "withTheme", "name"], Pn = ["classes"], Mn = (e, o = {}) => (n) => {
  const {
    defaultTheme: r,
    withTheme: a = !1,
    name: p
  } = o, b = Ce(o, On);
  if (process.env.NODE_ENV !== "production" && n === void 0)
    throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
  let f = p;
  if (process.env.NODE_ENV !== "production" && !p) {
    const k = It(n);
    k !== void 0 && (f = k);
  }
  const u = go(e, i({
    defaultTheme: r,
    Component: n,
    name: p || n.displayName,
    classNamePrefix: f
  }, b)), x = /* @__PURE__ */ h.forwardRef(function($, V) {
    const I = Ce($, Pn), O = u(i({}, n.defaultProps, $));
    let g, w = I;
    return (typeof p == "string" || a) && (g = yo() || r, p && (w = In({
      theme: g,
      name: p,
      props: I
    })), a && !w.theme && (w.theme = g)), /* @__PURE__ */ d(n, i({
      ref: V,
      classes: O
    }, w));
  });
  return process.env.NODE_ENV !== "production" && (x.propTypes = {
    /**
     * Override or extend the styles applied to the component.
     */
    classes: t.object
  }), process.env.NODE_ENV !== "production" && (x.displayName = `WithStyles(${It(n)})`), ho(x, n), process.env.NODE_ENV !== "production" && (x.Naked = n, x.options = o, x.useStyles = u), x;
}, Bn = Mn, Hn = ge(/* @__PURE__ */ d("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add"), Fn = ge(/* @__PURE__ */ d("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
}), "HelpOutline"), Wn = ge(/* @__PURE__ */ d("path", {
  d: "M8.12 9.29 12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7a.9959.9959 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0z"
}), "KeyboardArrowDownRounded"), Un = ge(/* @__PURE__ */ d("path", {
  d: "M19 13H5v-2h14v2z"
}), "Remove");
export {
  zn as A,
  An as C,
  Fn as H,
  Wn as K,
  _n as L,
  Dn as M,
  Un as R,
  Cn as S,
  jn as a,
  Hn as b,
  Vn as g,
  Bt as l,
  Co as v,
  Bn as w
};
//# sourceMappingURL=Remove-f6df6a52.js.map
